import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createBlogTopic = (_, payload) => {
  return Api(ENDPOINTS.BLOG_TOPIC.CREATE, payload, requestType.POST);
};

const updateBlogTopic = (id, payload) => {
  return Api(
    ENDPOINTS.BLOG_TOPIC.UPDATE.replace(":id", id),
    payload,
    requestType.PUT,
  );
};

const getBlogTopicById = (id) => {
  return Api(
    ENDPOINTS.BLOG_TOPIC.SINGLE.replace(":id", id),
    null,
    requestType.GET,
  );
};

const getBlogTopicBySlug = (slug) => {
  return Api(
    ENDPOINTS.BLOG_TOPIC.SINGLE_BY_SLUG.replace(":slug", slug),
    null,
    requestType.GET,
  );
};

const getBlogTopics = (params = {}) => {
  const ENDPOINT = ENDPOINTS.BLOG_TOPIC.GET;

  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;

  return Api(finalUrl, null, requestType.GET);
};

const getBlogTopicList = (params = {}) => {
  return Api(ENDPOINTS.BLOG_TOPIC.LIST, null, requestType.GET);
};

export {
  createBlogTopic,
  updateBlogTopic,
  getBlogTopicById,
  getBlogTopicBySlug,
  getBlogTopics,
  getBlogTopicList
};
